import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { getIsMarketSharesHidden } from "app/components/widget/widget-types/MarketAnalysis/helpers";

export const MarketShares = {
    id: "MarketShares",
    properties: {
        dashboard: "true",
        apiController: "WebsiteOverviewDesktop",
        title: "dashboard.metricGallery.Website.MarketShares.widget.title",
        family: "Industry",
        isHidden: getIsMarketSharesHidden,
        component: "IndustryAnalysis",
        totalComponent: "MarketPlayers",
        mobileWebComponent: "MobileMarketingMix",
        order: "1",
        keyPrefix: "$",
        state: "market_research_players",
        width: 4,
        timeGranularity: "Monthly",
        hasWebSource: true,
        newColorPalette: true,
        defaultDuration: "3m",
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL],
        },
    },
    widgets: {
        compare: {
            defaultType: "BarChart",
            MarketShares: {
                properties: {
                    showMoreButton: false,
                    periodOverPeriodSupport: false,
                    options: {
                        legendAlign: "left",
                        showLegend: true,
                        newColorPalette: true,
                    },
                },
                Visits: {
                    name: "Visits",
                    title: "Visits",
                    type: "double",
                    format: "None",
                    cellTemp: "",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
            MarketSharesGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: false,
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "number",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: false,
                },
                filters: {
                    // Monthly first: wizard uses [0] when unset; matches legacy non-window → Monthly fallback.
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                    ],
                },
            },
        },
        single: {
            defaultType: "BarChart",
            MarketShares: {
                properties: {
                    showMoreButton: false,
                    periodOverPeriodSupport: false,
                    options: {
                        legendAlign: "left",
                        showLegend: true,
                        newColorPalette: true,
                    },
                },
                Visits: {
                    name: "Visits",
                    title: "Visits",
                    type: "double",
                    format: "None",
                    cellTemp: "",
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
            MarketSharesGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: false,
                },
                y_axis: {
                    title: "Visits",
                    type: "double",
                    format: "number",
                    formatParameter: 0,
                    name: "Visits",
                    reversed: false,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                    ],
                },
            },
        },
    },
};
